<core-sidebar-wrapper (mouseenter)="isVersionShown.set(true)" (mouseleave)="isVersionShown.set(false)">
  <a title="Terabase" class="sidenav-logo" [routerLink]="'/construction/projects'">
    <img src="../../../../../assets/images/logo/logo-white.svg" alt="Terabase" />
  </a>
  <nav-items-container>
    <div class="separator"></div>
    <nav-items-group-container>
      <nav-items-group>
        <nav-item
          icon="calcite:grid-24"
          navTitle="Projects"
          [haveSubnavigation]="true"
          (mouseenter)="onProjectsHover()"
        >
          <div class="grid-item-12">
            <div class="subnav-heading">
              <span class="tb-primary">Projects</span>
              @if (isSuperAdmin()) {
                <div
                  class="tb-body-secondary flex-rec"
                  style="color: white"
                  [routerLink]="['/construction', 'projects', 'create']"
                >
                  <tbs-icon icon="calcite:plus-16" class="mr-1" />
                  Create New Project
                </div>
              }
            </div>
            <div class="separator"></div>
            <div
              class="subnav-project mt-1 mb-1"
              [routerLink]="['/construction', 'projects']"
              [routerLinkActive]="['active-nav-item']"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="title">
                <label class="tb-subtitle-primary">
                  <span>Portfolio</span>
                </label>
                <span class="tb-caption"> Portfolio dashboard overview </span>
              </div>
            </div>
            <div class="separator"></div>
            <nav-items-group-container>
              <nav-items-group>
                <div class="pinned">
                  @for (project of pinnedProjects(); track project._id) {
                    <div>
                      <div class="subnav-project" [routerLinkActive]="['active-nav-item']">
                        <div class="title" [routerLink]="['/construction/projects', project._id]">
                          <label class="tb-subtitle-primary">
                            <span>{{ project.project.project_name }}</span>
                          </label>
                          <span class="tb-caption">
                            <span>
                              <span>{{ project.project.location }}</span>
                              <tbs-icon icon="calcite:pin-24" />
                            </span>
                          </span>
                        </div>
                        <label class="styled-checkbox-container pin-section pl-1">
                          <input
                            #pinCheck
                            type="checkbox"
                            style="display: none"
                            [id]="'pinned-' + project._id"
                            [checked]="true"
                          />
                          <tbs-icon
                            size="medium"
                            class="project-star selected"
                            [id]="project._id"
                            [icon]="pinCheck.checked ? 'calcite:star-24-f' : 'calcite:star-24'"
                            [class.selected]="pinCheck.checked"
                            (click.throttle.3s)="pinCheck.checked = !pinCheck.checked; onPinProject(project, false)"
                          />
                        </label>
                      </div>
                    </div>
                  }
                </div>
              </nav-items-group>
              @if (hasBothSections()) {
                <mat-divider />
                <div class="separator"></div>
              }
              <nav-items-group>
                <div class="unpinned">
                  @for (project of unpinnedProjects(); track project._id) {
                    <div>
                      <div class="subnav-project" [routerLinkActive]="['active-nav-item']">
                        <div class="title" [routerLink]="['/construction/projects', project._id]">
                          <label class="tb-subtitle-primary">
                            <span>{{ project.project.project_name }}</span>
                          </label>
                          <span class="tb-caption">
                            <span>
                              <span>{{ project.project.location }}</span>
                            </span>
                            <span class="text-icon right">
                              <tbs-icon icon="calcite:pin-24" />
                            </span>
                          </span>
                        </div>
                        <label class="styled-checkbox-container pin-section pl-1">
                          <input #pinCheck type="checkbox" style="display: none" [id]="project._id" [checked]="false" />
                          <tbs-icon
                            size="medium"
                            class="project-star"
                            [id]="project._id"
                            [icon]="pinCheck.checked ? 'calcite:star-24-f' : 'calcite:star-24'"
                            [class.selected]="pinCheck.checked"
                            (click.throttle.3s)="pinCheck.checked = !pinCheck.checked; onPinProject(project, true)"
                          />
                        </label>
                      </div>
                    </div>
                  }
                </div>
              </nav-items-group>
            </nav-items-group-container>
          </div>
        </nav-item>
        @if (isSuperAdmin()) {
          <nav-item icon="calcite:gear-24" navTitle="Configuration" [routerLink]="['/construction', 'configuration']" />
        }

        @if (isCompanyAdmin()) {
          @if (canSeePortfolioStatus()) {
            <nav-item icon="terabase:drone-24" navTitle="Status" [routerLink]="['/construction', 'portfolio-status']" />
          }
          <nav-item icon="calcite:group-24" navTitle="Company" [routerLink]="['/companies', companyId()]" />
        }
      </nav-items-group>
    </nav-items-group-container>
  </nav-items-container>
  <nav-items-container style="margin-top: auto">
    <nav-items-group-container>
      <nav-items-group>
        <div class="nav-item profile-wrapper" (click)="openUsersProfile()">
          <span class="nav-link avatar">
            <core-image
              class="profile-picture"
              [imageId]="profilePicture()"
              [borderless]="true"
              [size]="profilePicture() ? 'cover' : '20px auto'"
              [dimensions]="{
                width: '32px',
                height: '32px',
              }"
            />
            <a class="inline-link">
              <span class="profile-name tb-subtitle-primary" [title]="userName()">
                {{ userName() }}
              </span>
            </a>
            <span class="icon">
              <tbs-icon icon="calcite:walk-through-door-24" title="Log Out" (click)="logout($event)" />
            </span>
          </span>
        </div>
        <a class="version" target="_blank" [routerLink]="['/release-notes']">
          @if (isVersionShown()) {
            <span>Version </span>
          }
          <span>{{ version }}</span>
        </a>
      </nav-items-group>
    </nav-items-group-container>
  </nav-items-container>
</core-sidebar-wrapper>
